import { render, staticRenderFns } from "./viewPenandaTangan.vue?vue&type=template&id=672c0ba2&"
import script from "./viewPenandaTangan.vue?vue&type=script&lang=js&"
export * from "./viewPenandaTangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QItemLabel,QIcon,QDialog,QCard,QCardSection,Ripple} from 'quasar'
component.options.components = Object.assign({QList,QItem,QItemSection,QItemLabel,QIcon,QDialog,QCard,QCardSection}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
